module.exports = __webpack_public_path__ + "img/MariSolMalibu_logo-NEGRO.cc1d113a.svg";